class NavDrawer extends HTMLElement {

  constructor() {
    super();

    this.overlay = document.getElementById("overlay");
    this.menuButton = document.getElementById("menu-toggle");
    this.closeButton = document.getElementById("menu__close-button");
    this.tabArr = this.querySelectorAll(".nav__tab");
    this.panelArr = this.querySelectorAll(".nav__panel");

    this.desktop = this.dataset.desktop;
    this.desktopInitiated = false;
    this.checkForDesktop = this.checkForDesktop.bind(this);
    this.checkForMobile = this.checkForMobile.bind(this);
    this.resetDrawer = this.resetDrawer.bind(this);

    this.debounceResize = this.debounce(this.addListeners.bind(this), 250); // Debounce the window resize event
    window.addEventListener('resize', this.debounceResize);

    this.cartToggle = document.getElementById('cart-toggle');
    if (this.cartToggle) {
      this.cartToggle.addEventListener("click", () => {
        window.location.href = window.location.href.split('#')[0] + "#cart";
        window.monster_refresh(true);
        console.log("Cart toggle clicked");
      });
    }
    
    this.overlay.addEventListener("click", this.mobileCollapse.bind(this));
    this.menuButton.addEventListener("click", this.mobileClick.bind(this));
    this.closeButton.addEventListener("click", this.mobileClick.bind(this));
    this.addListeners();
    this.initCurrencySelector();
  }

  debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  connectedCallback() {
    window.addEventListener('resize', this.debounceResize);
    
  }
  
  disconnectedCallback() {
    window.removeEventListener('resize', this.debounceResize);
  }

  addListeners() {
    this.resetDrawer();
    (window.innerWidth > 768) ? (this.desktop = true) : (this.desktop = false);
    this.checkForDesktop();
    this.checkForMobile();
  }

  checkForDesktop() {
    if (this.desktop) {
      // Store the bound event handler functions in variables
      const desktopExpandHandler = this.desktopExpand.bind(this);
      const desktopCollapseHandler = this.desktopCollapse.bind(this);
  
      this.tabArr.forEach(tab => {
        const panelId = tab.dataset.panel;
        const panel = document.getElementById(panelId);
  
        if (panel) {
          // Set up event listeners with the correct bound functions and parameters
          tab.addEventListener("mouseenter", event => desktopExpandHandler(panel, tab, event), false);
          tab.addEventListener("mouseleave", event => desktopCollapseHandler(panel, tab, event), false);
          panel.addEventListener("mouseenter", event => desktopExpandHandler(panel, tab, event), false);
          panel.addEventListener("mouseleave", event => desktopCollapseHandler(panel, tab, event), false);
        }
      });
      this.desktopInitiated = true;
    } else {
      this.tabArr.forEach(tab => {
        const panelId = tab.dataset.panel;
        const panel = document.getElementById(panelId);
  
        if (panel) {
          // Retrieve the same bound event handler functions for removal
          const desktopExpandHandler = this.desktopExpand.bind(this, panel, tab);
          const desktopCollapseHandler = this.desktopCollapse.bind(this, panel, tab);
  
          tab.removeEventListener("mouseenter", desktopExpandHandler, false);
          tab.removeEventListener("mouseleave", desktopCollapseHandler, false);
          panel.removeEventListener("mouseenter", desktopExpandHandler, false);
          panel.removeEventListener("mouseleave", desktopCollapseHandler, false);
        }
      });
      this.dataset.desktop = false;
      this.desktopInitiated = false;
    }
  }

  checkForMobile() {
  if (!this.desktop) {
    // Store the bound event handler function in a variable
    const switchTabHandler = this.switchTab.bind(this);

    this.tabArr.forEach(tab => {
      const panelId = tab.dataset.panel;
      const panel = document.getElementById(panelId);

      if (panel) {
        // Set up the event listener with the correct bound function and parameters
        tab.addEventListener("click", event => {
          event.preventDefault(); // Prevent link navigation
          switchTabHandler(panel, tab);
        }, false);
      } else {
        // Regular link
        tab.addEventListener("click", event => {
          tab.classList.add("selected");
        });
      }
    });

  } else {
    this.tabArr.forEach(tab => {
      const panelId = tab.dataset.panel;
      const panel = document.getElementById(panelId);

      if (panel) {
        // Retrieve the same bound event handler function for removal
        const switchTabHandler = this.switchTab.bind(this, panel, tab);

        tab.removeEventListener("click", switchTabHandler, false);
      } else {
        // Regular link
        tab.removeEventListener("click", event => {
          tab.classList.remove("selected");
        });
      }
    });
  }
}
  
  switchTab(panel, tab) {
    if (panel == null && tab == null) {
      // ON OPEN
      const panelArr = Array.from(this.panelArr);
      panelArr[0].classList.add("active");
      
      const tabArr = Array.from(this.tabArr);
      tabArr[0].classList.add("active");
      
      panelArr.slice(1).forEach(panelElement => {
        panelElement.classList.remove("active");
      });
      
      tabArr.slice(1).forEach(tabElement => {
        tabElement.classList.remove("active");
      });

    } else {

      // ON TAB SELECT
      this.panelArr.forEach(panelElement => {
        if (panelElement == panel) {
          panelElement.classList.add("active");
        } else {
          panelElement.classList.remove("active");
        }
      });
  
      this.tabArr.forEach(tabElement => {
        if (tabElement == tab) {
          tabElement.classList.add("active"); 
        } else {
          tabElement.classList.remove("active");
        }
      });
    }
  }

  resetDrawer() {
    // Reset the state of the drawer here
    this.overlay.classList.remove("active");
    this.menuButton.setAttribute("aria-expanded", false);

    // Reset tab and panel states
    this.tabArr.forEach(tabElement => {
      tabElement.classList.remove("active");
    });

    this.panelArr.forEach(panelElement => {
      panelElement.classList.remove("active");
    });

    // If needed, you can add any other reset logic here
  }

  desktopExpand(panel, tab) {
    this.overlay.classList.add("active");
    tab.setAttribute("aria-expanded", true);
    panel.classList.add("active");
  }

  desktopCollapse(panel, tab) {
    this.overlay.classList.remove("active");
    tab.setAttribute("aria-expanded", false);
    panel.classList.remove("active");
  }

  mobileCollapse() {
    this.menuButton.setAttribute("aria-expanded", false);
    this.overlay.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  mobileExpand() {
    try{
      window.closeCart();
    } catch {
      console.log("Can't close cart.");
    }
    
    this.menuButton.setAttribute("aria-expanded", true);
    this.overlay.classList.add("active");
    document.body.classList.add("overflow-hidden");
    this.switchTab(null, null);
  }

  mobileClick() {
    if (this.menuButton.getAttribute("aria-expanded") == 'true') {
      this.mobileCollapse();
    } else {
      this.mobileExpand();
    }
  }

  initCurrencySelector() {
    const currencySelectors = document.querySelectorAll('[data-currency-selector]');
    if (currencySelectors.length > 0) {
      currencySelectors.forEach(select => {
        select.addEventListener('change', function(event) {
          // Add a loading state to indicate something is happening
          select.classList.add('loading');
          
          // Get the form
          const form = this.closest('form');
          if (form) {
            // Use fetchConfig pattern from your global.js
            const formData = new FormData(form);
            
            // Build request options similar to your other forms
            const requestOptions = {
              method: 'POST',
              body: formData
            };
            
            // Submit the form with fetch to avoid page reload
            fetch(form.action, requestOptions)
              .then(response => {
                if (response.ok) {
                  // If successful, reload the page to show the new currency
                  window.location.reload();
                } else {
                  console.error('Error updating currency');
                  select.classList.remove('loading');
                }
              })
              .catch(error => {
                console.error('Error:', error);
                select.classList.remove('loading');
                
                // Fallback to traditional form submission
                form.submit();
              });
          } else {
            // If no form is found, fallback to reloading with the currency parameter
            window.location.href = window.location.href.split('?')[0] + '?currency=' + this.value;
          }
        });
      });
    }
  }
  
}

customElements.define('nav-drawer', NavDrawer);
